<div class="ds-badge" [ngClass]="type">
  <span class="ds-caption-3">
    <ng-content></ng-content>
  </span>
</div>
